import { render, staticRenderFns } from "./allocationRules.vue?vue&type=template&id=bf7e3ac8&scoped=true&"
import script from "./allocationRules.vue?vue&type=script&lang=js&"
export * from "./allocationRules.vue?vue&type=script&lang=js&"
import style0 from "./allocationRules.vue?vue&type=style&index=0&id=bf7e3ac8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7e3ac8",
  null
  
)

export default component.exports